let initializedFromOperation:Map<string, string> = new Map<string, string>(); // key is viewIndex, value is operation

export function useMemoListOperationStorage() {
  function hasViewIndex(viewIndex: string) {
    return initializedFromOperation.has(viewIndex);
  }

  function getViewIndex(viewIndex: string): string {
    const result = initializedFromOperation.get(viewIndex);
    if (!result) {
      throw new Error('Invalid operation');
    }

    return result;
  }

  function setViewIndex(viewIndex: string, operation: string) {
    initializedFromOperation.set(viewIndex, operation);
  }

  function deleteViewIndex(viewIndex: string) {
    initializedFromOperation.delete(viewIndex);
  }

  return {
    hasViewIndex,
    getViewIndex,
    setViewIndex,
    deleteViewIndex,
  };
}
